var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudDropDisabledGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 70,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.998 52.493a16.886 16.886 0 00-6.268-13.408 14.647 14.647 0 01-7.732 6.833 14.655 14.655 0 002.356-24.459 14.657 14.657 0 00-8.986-3.193 9.237 9.237 0 00-1.468.077 33.323 33.323 0 012.75 12.392h-.219a34.642 34.642 0 00-68.842 0h-.228c.03-4.212.893-8.377 2.54-12.255C9.237 20.08 0 30.872 0 44.08A25.8 25.8 0 0025.685 70H91.01v-.027a17.417 17.417 0 0016.988-17.48z",
    fill: "#F4F5F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.497 51.018a.5.5 0 01-.5-.5v-12.5h-9.793a.499.499 0 01-.353-.855l16.793-16.79a.499.499 0 01.705 0l16.795 16.79a.5.5 0 01-.355.855h-9.792v12.5a.5.5 0 01-.5.5h-13z",
    fill: "#ACACAE"
  })));
}
export default SvgCloudDropDisabledGrey;